<footer>
  <p>
    © 2025 All rights reserved.
    <span *ngIf="version" class="footer-version">v{{ version }}</span>
  </p>
</footer>
